import React from 'react'
import {Route} from 'react-router-dom'
import {SuspensedView} from '@/components/SuspensedView'

import CustomersPage from './customers/CustomersPage'
import ProductsPage from './products/ProductsPage'
import BrandsPage from './brands/BrandsPage'
import SuppliersPage from './suppliers/SuppliersPage'
import PaymentPage from './payment/PaymentPage'
import SettingsPage from './settings/SettingsPage'
import SalesPage from './sales/SalesPage'
import SponsorshipsPage from './sponsorships/SponsorshipsPage'
import DashboardPage from './dashboard/DashboardPage'
import LogsPage from './logs/LogsPage'
import SupportPage from './support/SupportPage'
import AnalyticsPage from './analytics/AnalyticsPage'

const useP2cRoutes = () => (
  <>
    <Route
      path='p2c/dashboard/*'
      element={
        <SuspensedView>
          <DashboardPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/analytics/*'
      element={
        <SuspensedView>
          <AnalyticsPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/sales/*'
      element={
        <SuspensedView>
          <SalesPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/sponsorships/*'
      element={
        <SuspensedView>
          <SponsorshipsPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/customers/*'
      element={
        <SuspensedView>
          <CustomersPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/payment/*'
      element={
        <SuspensedView>
          <PaymentPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/supplier/*'
      element={
        <SuspensedView>
          <SuppliersPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/product/*'
      element={
        <SuspensedView>
          <ProductsPage />
        </SuspensedView>
      }
    />
    <Route
      path='p2c/brands/*'
      element={
        <SuspensedView>
          <BrandsPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/settings'
      element={
        <SuspensedView>
          <SettingsPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/logs/*'
      element={
        <SuspensedView>
          <LogsPage />
        </SuspensedView>
      }
    />

    <Route
      path='p2c/support/*'
      element={
        <SuspensedView>
          <SupportPage />
        </SuspensedView>
      }
    />

  </>
)

export {useP2cRoutes}
